'use strict';

const baseSearch = require('brand_core/components/search');

module.exports = function () {
    baseSearch.init();
};
